export default [
  {
    path: '/type-certificate',
    name: 'type-certificate',
    component: () => import('@/views/type-certificate/TypeCertificate.vue'),
  },
  {
    path: '/type-certificate/add',
    name: 'add-type-certificate',
    component: () => import(
      '@/views/type-certificate/control-type-certificate/AddEditTypeCertificate.vue'
    ),
    meta: {
      title: 'Add Type Certificate ',
      requiresAuth: true,
      action: 'create',
      resource: 'Type Certificate',
      pageTitle: 'Type Certificate',
      breadcrumb: [
        {
          text: 'Type Certificate',
          to: '/type-certificate',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/type-certificate/edit/:id',
    name: 'edit-type-certificate',
    component: () => import(
      '@/views/type-certificate/control-type-certificate/AddEditTypeCertificate.vue'
    ),
    meta: {
      title: 'Edit Type Certificate ',
      requiresAuth: true,
      pageTitle: 'Type Certificate',
      breadcrumb: [
        {
          text: 'Type certificate',
          to: '/type-certificate',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
